import React from 'react';
import { PeoplePickerButton } from '@shared/components/PeoplePicker';
import type { PeoplePickerUseCase } from '@shared/components/PeoplePicker';
import { TextV2, IconV2 } from '@withjoy/joykit';
import { SelectRecipientsEmail } from '@withjoy/joykit/icons';
import type { PostOfficeMessageType, EcardType } from '@graphql/generated-base';
import { useEcardsTelemetry } from '@apps/ecard/Ecard.telemetry';
import { useTranslation } from '@shared/core';

interface PeoplePickerProps
  extends Readonly<{
    buttonTextDefault: string;
    buttonTextHover: string;
    eventHandle: string;
    draftType: PostOfficeMessageType | EcardType;
    buttonWidth?: number;
    disabled?: boolean;
    onStartSelection?: () => void;
    useCase: PeoplePickerUseCase;
  }> {}

export const PeoplePicker: React.FC<PeoplePickerProps> = ({ buttonTextDefault, buttonTextHover, eventHandle, draftType, buttonWidth, disabled, onStartSelection, useCase }) => {
  const telemetry = useEcardsTelemetry();
  const { tq } = useTranslation('emailsAndEcards');

  const handleStartSelection = () => {
    telemetry.selectGuestsClicked(draftType);
    onStartSelection?.();
  };

  return (
    <PeoplePickerButton
      eventHandle={eventHandle}
      title={
        <TextV2
          typographyVariant="hed4"
          color="mono14"
          display="flex"
          alignItems="center"
          fontSize="24px"
          lineHeight="1"
        >
          <IconV2
            size="md"
            marginRight="12px"
          >
            <SelectRecipientsEmail />
          </IconV2>{' '}
          {tq`Select Guests`}
        </TextV2>
      }
      buttonTextDefault={buttonTextDefault}
      buttonTextHover={buttonTextHover}
      width={buttonWidth ?? 'initial'}
      disabled={disabled}
      onStartSelection={handleStartSelection}
      useCase={useCase}
    />
  );
};
